import React from 'react'
import MobileAdmitAI from './MobAdmitAi'

const AdmitAiMobWrapper = () => {
  return <MobileAdmitAI />
}

export default AdmitAiMobWrapper
